import { RedirectEndpointEnum } from '@/modules/Sites';

import { ExternalRedirectFormFields, ExternalRedirectTargetType } from '@/modules/ExternalRedirects';

export const normalizeExternalRedirectPayload = (values: ExternalRedirectFormFields): ExternalRedirectFormFields => {
  const next: ExternalRedirectFormFields = { ...values };

  if (next.sourceType === RedirectEndpointEnum.Node) {
    next.sourcePath = undefined;
  } else {
    next.sourceNodeId = undefined;
  }

  if (next.toType === ExternalRedirectTargetType.SystemDomain) {
    next.toExternalDomain = undefined;
    next.toSiteId = undefined;
  } else if (next.toType === ExternalRedirectTargetType.ExternalDomain) {
    next.toDomainId = undefined;
    next.toSiteId = undefined;
    // Зовнішній домен не має сторінкової структури в системі — ціль може бути лише шляхом.
    next.targetType = RedirectEndpointEnum.Path;
  } else {
    next.toDomainId = undefined;
    next.toExternalDomain = undefined;
  }

  if (next.targetType === RedirectEndpointEnum.Node) {
    next.targetPath = undefined;
  } else {
    next.targetNodeId = undefined;
  }

  return next;
};
